import { useReducer } from 'react';

export const useSpreadState = (initial = {}) => (
  useReducer((prev, next) => ({ ...prev, ...next }), initial)
);

export default useSpreadState;
